import { call, put } from 'redux-saga/effects';

import { deleteOutputFileFailure, deleteOutputFileSuccess } from '@actions/gameChanger';
import { deleteOutputFileRequest } from '@api/gameChanger';
import { fetchGameChangerOutputFileIdsSaga } from '@sagas/gameChanger/fetchGameChangerOutputFileIdsSaga';
import { toastError } from '@store/notifications';

export const deleteOutputFilesSaga = function* ({ payload }) {
  try {
    yield call(deleteOutputFileRequest, payload);
    yield call(fetchGameChangerOutputFileIdsSaga, { payload });

    yield put(deleteOutputFileSuccess(payload));
  } catch (error) {
    const { nonFieldErrors } = error.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      }),
      deleteOutputFileFailure(payload),
    ]);
  }
};
